/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Contact_Email_LabelInputs */

const es_tyc_contact_email_label = /** @type {(inputs: Tyc_Contact_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correo Legal`)
};

const en_tyc_contact_email_label = /** @type {(inputs: Tyc_Contact_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal Email`)
};

/**
* | output |
* | --- |
* | "Legal Email" |
*
* @param {Tyc_Contact_Email_LabelInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_contact_email_label = /** @type {((inputs?: Tyc_Contact_Email_LabelInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Contact_Email_LabelInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_contact_email_label(inputs)
	return en_tyc_contact_email_label(inputs)
});
export { tyc_contact_email_label as "tyc.contact.email_label" }